import React from "react";
import { Link } from "react-router-dom";
import { Row, Col, InputGroup, Input } from "reactstrap";
import logo from "static/logo.png";
import { CallToAction } from "components/CallToAction";
import { UserButton } from "account/UserButton";
import { openHelpModal } from "components/search/Help";
import { QueryType, QueryTypeLabel, StatusType } from "data/Types";
import styles from "./SearchBar.module.css";

import { useAuth, useSearch, useQuery } from "hooks";

const getQueryTypeActions = (setQuery) => {
  const actions = [];
  for (let type of Object.keys(QueryType)) {
    // if ([QueryType.PUBLICATION, QueryType.PATENT].includes(type)) {
    //   actions.push({});
    // }
    actions.push({
      value: type,
      label: QueryTypeLabel[type],
      action: () => setQuery({ type }),
    });
  }
  return actions;
};

const SearchBar = () => {
  const search = useSearch();
  const query = useQuery();
  const auth = useAuth();
  const helpAction = [
    {
      value: "help",
      label: "Help",
      icon: "info",
      action: openHelpModal,
    },
  ];
  const searchActions = [
    {
      value: "search",
      label: "Search",
      icon: "search",
      action: search.actions.execute,
    },
  ];
  if (search.status & StatusType.Result && auth.user) {
    searchActions.push({
      value: "save",
      label: "Save",
      icon: "star",
      action: query.actions.create,
    });
  }
  /** #256 Remove due to UX feedback
  if (search.status > 0) {
    searchActions.push({
      value: "reset",
      label: "Reset",
      icon: "times",
      action: search.actions.reset,
    });
  } /**/
  return (
    <Row
      tag="form"
      onSubmit={(e) => {
        e.preventDefault();
        if (
          !search.query.query ||
          (search.status & StatusType.Queried &&
            !(search.status & StatusType.Result))
        ) {
          return false;
        }
        search.actions.execute();
        return false;
      }}
    >
      <Col xs={2} className="logo">
        <Link to="/" title="Start a new query" onClick={search.actions.reset}>
          <img className="img-fluid rounded" src={logo} alt="logo" />
        </Link>
      </Col>
      <Col xs={6}>
        <InputGroup>
          <CallToAction
            items={getQueryTypeActions(search.setQuery)}
            value={search.query.type}
            addonType="prepend"
            right={false}
          />
          <Input
            className={styles.input}
            name="q"
            placeholder="Search KnowING IPR database..."
            value={search.query.query}
            readOnly={search.query.isAdvanced}
            onChange={(e) => {
              search.setQuery({ query: e.target.value });
            }}
          />
          <CallToAction
            items={searchActions}
            value="search"
            color="primary"
            align="right"
            addonType="append"
            split
            spinner={!!(search.status & StatusType.Querying)}
            disabled={!search.query.query}
          />
        </InputGroup>
      </Col>
      <Col xs={2}>
        <CallToAction
          className={styles.button}
          color="warning"
          split
          items={helpAction}
          value="help"
        />
      </Col>
      <Col xs={2}>
        <UserButton />
      </Col>
    </Row>
  );
};

export { SearchBar };
